<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h2 class="chapterhead">Contents</h2>
<div>
<p class="ToC1">
<span href="#/cover" title="Link target outside of Sample">Cover</span>
</p>
<div>
<p class="ToC3">
<span href="#/cover#credits" title="Link target outside of Sample">Imprint</span>
</p>
</div>
<div>
<p class="ToC3">
<span href="#/cover#dedication" title="Link target outside of Sample">Dedication</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<a href="#/chapter1">Preface</a>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<a href="#/chapter2">Foreword</a>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<a href="#/chapter3">Buffalo, Wings, and a Prayer</a>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<a href="#/chapter4">A New Life Out West</a>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<a href="#/chapter5">Changes, Challenges, and Choices</a>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter6" title="Link target outside of Sample">Innocence Interrupted</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter7" title="Link target outside of Sample">The Highs and Lows of High School</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter8" title="Link target outside of Sample">Escaping CP Land through TV Land</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter9" title="Link target outside of Sample">Waiting in the Wings of College</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter10" title="Link target outside of Sample">Sneaking into the Store and Stealing the Spotlight</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter11" title="Link target outside of Sample">My First “Funny Business” Manager</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter12" title="Link target outside of Sample">Another Suitcase, Another Hall</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter13" title="Link target outside of Sample">Nice Dreams</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter14" title="Link target outside of Sample">Out of the Closet, Onto a Pedestal</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter15" title="Link target outside of Sample">Big Dreams, Dark Shadows, and Frolicking in Between</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter16" title="Link target outside of Sample">Breaking Up Is Hard to Do</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter17" title="Link target outside of Sample">The Three Faces of Geri: Jewell, Warner, and Tyler</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter18" title="Link target outside of Sample">Touring with “Geri”</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter19" title="Link target outside of Sample">From Sesame Street to 1600 Pennsylvania Avenue</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter20" title="Link target outside of Sample">The People You Meet on the Way Down</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter21" title="Link target outside of Sample">An Amazing Decade of Making Lemonade</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter22" title="Link target outside of Sample">Richard, My Ex-Husband</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter23" title="Link target outside of Sample">Honesty Within</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter24" title="Link target outside of Sample">Building on a Shaky Foundation</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter25" title="Link target outside of Sample">Finding My Way Back Home</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter26" title="Link target outside of Sample">My Ground Zero</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter27" title="Link target outside of Sample">The Three Ds: Divorce, Deadwood, and Determination</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter28" title="Link target outside of Sample">Thank You</span>
</p>
</div>
</div>
<div>
<div>
<p class="ToC1">
<span href="#/chapter29" title="Link target outside of Sample">Photo Section</span>
</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?355473f9